export default __webpack_public_path__ + "images/animoto-plans-pricing.png";